<template>
  <div class="mt-5 mb-5 vx-row">
    <div class="vx-col w-full mb-4 text-right" v-if="$store.state.uInfo.role == 'U'">
      <div>
        <vue-json-to-csv :json-data="csvMonthData" :csv-title="'MonthData'">
          <vs-button class="gradient-btn">
            <feather-icon icon="DownloadIcon" title="Download CSV" class></feather-icon>
          </vs-button>
        </vue-json-to-csv>
        <vs-button
          class="ml-1 gradient-btn"
          target="_blank"
          title="Download PDF"
          @click="generateMonthPDF"
        >
          <feather-icon icon="FileTextIcon" class></feather-icon>
        </vs-button>
      </div>
    </div>
    <div :class="$store.state.uInfo.role !== 'U' ? 'vx-col w-full' : 'vx-col w-1/2'">
      <vs-table
        :data="monthlySearchresult"
        class="stickyCol-tbl monthinout-tbl"
      >
        <template slot="header" v-if="$store.state.uInfo.role !== 'U'">
          <!-- <div class="datepicker-main">
            <div class="datewrapper">
              <label for class="float-right w-auto">Select Month</label>
              <datepicker :calendar-button="true" calendar-button-icon="fa fa-calendar"
                placeholder="Select Date"
                class="float-right calendar-icon-right top-45"
                format="MMMM"
                :minimumView="'month'"
                :maximumView="'month'"
                v-model="current_month"
                :disabledDates="disabledDates"
              ></datepicker>
            </div>
          </div> -->
          <!-- <div>
            <vue-json-to-csv :json-data="csvMonthData" :csv-title="'MonthData'">
              <vs-button class="gradient-btn">
                <feather-icon icon="DownloadIcon" title="Download CSV" class></feather-icon>
              </vs-button>
            </vue-json-to-csv>
            <vs-button
              class="ml-1 gradient-btn"
              target="_blank"
              title="Download PDF"
              @click="generateMonthPDF"
            >
              <feather-icon icon="FileTextIcon" class></feather-icon>
            </vs-button>
          </div> -->
          <div v-if="$store.state.uInfo.role !== 'U'" class="total-hours">
            Total Hours:
            <span
              class="font-bold"
            >{{convertToTime(totalActiveMinutesOfMonth)}}</span>
          </div>
          <!-- <label for="" class="vs-input--label float-right">Select Month</label> -->
        </template>
        <template slot="thead">
          <vs-th class="sticky-col user-col">User</vs-th>
          <vs-th
            v-for="(dates,index) in MonthDates"
            :key="index"
            v-if="$store.state.uInfo.role !== 'U'"
          >
            {{ dates.Date }}
            <br />
            {{ dates.Day }}
          </vs-th>
          <vs-th
            v-if="$store.state.uInfo.role !== 'U'"
            class="sticky-col totaltime-col"
          >Total Time</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td class="sticky-col user-col">
              <!-- <vx-tooltip :text="tr.user_name.toUpperCase()"> -->
                <div class="relative inline-flex float-left">
                    <!--<vs-avatar class="m-0" :src="require(`@/assets/images/portrait/small/avatar-s-11.png`)" size="40px"/>-->
                    <vs-avatar
                    class="m-0"
                    :src="tr.profile_image"
                    size="40px"
                    v-if="tr.profile_image"
                    />
                    <vs-avatar
                    color="primary"
                    class="m-0 name-avatar"
                    :text="usernameList(tr.firstname,tr.lastname)"
                    size="40px"
                    v-else
                    />
                    <div
                    class="h-3 w-3 border-white border border-solid rounded-full absolute pin-r pin-b"
                    :class="'bg-success'"
                    ></div>
                </div>
                <h6 class="mt-2 ml-16 break-words">{{ tr.user_name }}</h6>
              <!-- </vx-tooltip> -->
            </vs-td>
            <!-- TO DO Calendar Implement -->
            <vs-td
              v-for="(times,index) in tr.dateWiseData"
              :key="index"
              v-if="$store.state.uInfo.role !== 'U'"
            >
              <vx-tooltip text="View timesheet details">
                <div :class="times.is_user_was_on_leave?'time-box-warning':'time-box'" @click="openTimesheetSlidebar(tr.user_id,times.date)">
                  <span>{{convertToTime(times.activeMinutes + times.outMinutes)}} {{ times.is_user_was_on_leave?'L':'' }}</span>
                </div>
              </vx-tooltip>
            </vs-td>
            <vs-td
              v-if="$store.state.uInfo.role !== 'U'"
              class="sticky-col totaltime-col"
            >{{ convertToTime(tr.totalActiveMinutes + tr.totalOutMinutes) }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
    <div class="vx-col w-full mt-5">
      <div class="justify-between flex mb-2">
        <p>
          Days worked:
          <span class="font-bold">{{this.daysWorked}}</span>
        </p>
        <p>
          Total Hours:
          <span
            class="font-bold"
          >{{convertToTime(this.totalActiveMinutesOfMonth)}}</span>
        </p>
      </div>
      <full-calendar
        ref="calendar"
        class="w-full"
        :event-sources="eventSources"
        @event-selected="eventSelected"
        :config="config"
      ></full-calendar>
    </div>
       <div class="monthlyTimesheetprintpdf hidden">
            <div id="monthprintpdf">
          <table width="100%" style="border-collapse: collapse;width:100%;margin:0px 10px 10px 10px;" id="monthpdfHeader">
            <tbody>
             <tr style="border-collapse: collapse;border:0;">
                  <td style="min-width:90px;max-width:90px;letter-spacing: 0px;color:#000;font-size:5px;border: 0px;border-collapse: collapse;">Monthly Timesheet</td>
                  <td style="min-width:100px;max-width:100px;letter-spacing: 0px;color:#000;font-size:5px;border: 0px;border-collapse: collapse;text-align:right;">{{ $store.state.uInfo.org_name }}</td>
              </tr>
            <tr style="border-collapse: collapse;" v-if="office_id">
            <td style="letter-spacing: 0px;padding:3px 3px;font-size:5px;min-width:100px;color:#000;">Office: {{ officepdf }} </td> 
            </tr >
            <tr style="border-collapse: collapse;">
              <td style="letter-spacing: 0px;padding:3px 3px;font-size:5px;min-width:100px;color:#000;" colspan="2">Month: <span>{{monthNamepdf}}</span></td>
            </tr>
            </tbody>
          </table>
          <table width="100%" style="width:100%;border-collapse: collapse;border:0;margin:0px 10px;" id="monthlypdf">
            <thead>
              <tr style="border-collapse: collapse;border:0;">
                  <th style="letter-spacing: 0px;min-width:55px;max-width:55px;font-size:6px;border: 1px solid #abc0e4;border-right:0 !important;border-collapse: collapse;padding:3px 3px 5px 3px;color:#fff;background:#4472c4;">User</th>
                  <th v-for="(dates,index) in MonthsPdf" :key="index">
                      {{ dates.Date }}
                  </th>
                <th class="sticky-col totaltime-col">Total Time</th>
              </tr>
            </thead>
            <tbody>
              <tr :key="indextr" v-for="(tr, indextr) in monthlySearchresult" style="border-collapse: collapse;border:0;">
                <td>{{ tr.firstname | capitalize}} {{tr.lastname | capitalize}}</td>
             <td
              v-for="(times,index) in tr.dateWiseData"
              :key="index"
              v-if="$store.state.uInfo.role !== 'U'"
            >
                  <span>{{convertToTime(times.activeMinutes + times.outMinutes)}}</span> 
            </td>
            <td
              v-if="$store.state.uInfo.role !== 'U'"
              class="sticky-col totaltime-col"
            >{{ convertToTime(tr.totalActiveMinutes + tr.totalOutMinutes) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        </div>
  </div>
</template>

<script>
import { EventBus } from '@/mixins/mixin.js';
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import VueJsonToCsv from "vue-json-to-csv";
import moment from "moment";
import jsPDF from "jspdf";
import autoTable from 'jspdf-autotable'
import "fullcalendar/dist/fullcalendar.css";
export default {
  components: {
    Datepicker,
    flatPickr,
    jsPDF,
    vSelect,
    "vue-json-to-csv": VueJsonToCsv
  },
  props: {
    office_id: {
        required: false,
        default: 'all',
        type: String
    },
    department_id: {
        required: false,
        default: 'all',
        type: Array
    },
    current_month: {
      required: true,
      default: new Date(),
    },
    search: {
      required: false,
      default: null,
    },
  },
  data() {
    return {
      timezone: this.$store.state.uInfo.timeZone,
      // disabledDates: {
      //   from: new Date(
      //     new Date().getFullYear(),
      //     new Date().getMonth(),
      //     new Date().getDate() + 1
      //   ) // Disable all dates after specific date
      // },
      perPage: 25,
      totalPage: 1,
      currentPage: 1,
      MonthlyTimeSheet: [],
      monthlySearchresult: [],
      MonthDates: [],
      MonthsPdf:[],
      monthNamepdf:'',
      
      // current_month: new Date(),
      config: {
        defaultView: "month",
        eventClick: event => {
          this.selected = event;
          this.openTimesheetSlidebar(this.MonthlyTimeSheet[0].user_id, event.date);
        }
      },
      format: "dd/MM/yyyy",
      totalActiveMinutesOfMonth: null,
      csvMonthData: [],
      daysWorked: null,
      selected: {},
      officepdf:'',
    };
  },
  mounted: function() {
      this.getMonthlyDate();
      this.getMonthlyTimeSheet();
      EventBus.$on('reload_details', () => {
        this.getMonthlyTimeSheet();
      });
      EventBus.$on("monthTimesheetPDF", () => {
        this.generateMonthPDF();
      });
  },
  watch: {
    office_id(nv) {
      if (nv) {
        this.getOfficeAndDepartment();
      }
        this.getMonthlyTimeSheet();
    },
    department_id(nv) {
    //  if (nv) {
        this.getMonthlyTimeSheet();
      //}
    },
    currentPage(nv) {
      if (nv) {
        this.getItems();
      }
    },
    perPage(nv) {
      if (nv) {
        this.getItems();
      }
    },
    current_month(nv) {
      if (nv) {
        this.getMonthlyDate();
        this.getMonthlyTimeSheet();
      }
    },
    search(nv) {
      if (!nv) {
        this.perPage = 25;
        this.currentPage = 1;
        this.monthlySearchresult = this.MonthlyTimeSheet;
        if (this.$refs.paginationApplication) {
          this.$refs.paginationApplication.current = 1;
        }
        // this.getItems();
      }
      if (nv) {
        let result2 = this.MonthlyTimeSheet.filter(e => {
          if (
            e.firstname.toLowerCase().includes(this.search.toLowerCase()) ||
            e.lastname.toLowerCase().includes(this.search.toLowerCase())
          ) {
            return true;
          } else {
            return false;
          }
        });
        this.monthlySearchresult = result2;         
      }
    }
  },
  computed: {
    eventSources() {
      const self = this;
      return [
        {
          events(start, end, timezone, callback) {
            setTimeout(() => {
              callback(
                self.MonthlyTimeSheet[0].dateWiseData.map(d => {
                  return {
                    ...d,
                    start: d.date,
                    title: self.convertToTime(d.activeMinutes).toString(),
                    allDay: true
                  };
                })
              );
            }, 1000);
          }
        }
      ];
    }
  },
  methods: {
    openTimesheetSlidebar(id,current_date){
      let data = {
        id: id,
        current_date: current_date,
        type: 'day',
        isUserTimeSheet:true,
      }
      EventBus.$emit('open_timesheet_sidebar', data);
    },
    eventSelected(event) {
      this.selected = event;
    },
    generateActivityMonthPDF() {
      const doc = new jsPDF();
      var finalY = doc.lastAutoTable.finalY || 10;
      doc.text("WeekWise Data of User", 14, finalY + 15);
      doc.autoTable({
        body: this.csvWeekData,
        startY: finalY + 20,
        columns: [
          { header: "User", dataKey: "User" },
          { header: "Date", dataKey: "Date" },
          { header: "Status", dataKey: "Status" },
          { header: "Start Time", dataKey: "Start Time" },
          { header: "Notes", dataKey: "Notes" }
        ]
      });
      doc.save("MonthData.pdf");
    },
    generateMonthPDF() {
      var doc = new jsPDF('l', 'mm', [497, 410]);
      autoTable(doc, { html: '#monthpdfHeader' })
      autoTable(doc, { html: '#monthlypdf' })
      doc.save("Monthly Data.pdf")
      // const doc = new jsPDF();
      // var finalY = doc.lastAutoTable.finalY || 10;
      // doc.text("MonthWise Data of User", 14, finalY + 15);
      // let columns = [];
      // this.csvMonthData.forEach(w => {
      //   var keys = Object.keys(w);
      //   keys.forEach(k => {
      //     columns.push({ header: k, dataKey: k });
      //   });
      // });
      // doc.autoTable({
      //   body: this.csvMonthData,
      //   startY: finalY + 20,
      //   columns,
      //   tableWidth: "wrap",
      //   styles: { cellPadding: 0.5, fontSize: 8, overflow: "linebreak" }
      // });
      // doc.save("MonthData.pdf");
    },
    usernameList(firstname, lastname) {
      if (firstname && lastname) {
        let first = firstname.trim().charAt(0);
        let last = lastname.trim().charAt(0);
        let name = first.concat(last);
        return name.toUpperCase();
      }
      /*  return firstname.trim() + " " + lastname.trim(); */
    },
    getMonthlyDate() {
      let monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "April",
        "May",
        "Jun",
        "Jul",
        "Augt",
        "Sep",
        "October",
        "Nov",
        "Dec"
      ];
      let d = new Date();
      let year = d.getFullYear();
      let month = moment(this.current_month).format("MM") - 1;
      this.monthNamepdf = moment(this.current_month).format("MMMM");
      let names = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      let date = new Date(year, month, 1);
      let result = [];
      let resultpdf = [];
      while (date.getMonth() == month) {
        //
        let dd = date.getDate() + " " + monthNames[date.getMonth()];
        result.push({
          Date: dd,
          Day: names[date.getDay()]
        });
        let dm = date.getDate();
        resultpdf.push({
          Date: dm,
          Day: names[date.getDay()]
        })
        date = new Date(year, month, date.getDate() + 1);
      }
      this.MonthDates = result;
      this.MonthsPdf = resultpdf;
    },

    convertToTime(totalMinutes) {
      if (totalMinutes) {
        const addZero = d => (d > 9 ? d.toString() : "0" + d.toString());
        let hours = addZero(Math.floor(totalMinutes / 60));
        let minutes = addZero(totalMinutes % 60);

        return hours + ":" + minutes;
      } else {
        return "00:00";
      }
    },
    async getMonthlyTimeSheet() {
      this.$vs.loading({
        color: "primary"
      });

      let month = moment.tz(this.current_month, this.timezone).format('MM');

      let url = "inout/getMonthlyTimeSheet";
      url += "?month=" + month;
      if (this.$store.state.uInfo.role == "U") {
        url += "&user_id=" + this.$store.state.uInfo.id;
      } else {
        let office = this.office_id ? this.office_id : 'all';
        let department = this.department_id ? this.department_id.toString() : ''
        url += "&office_id="+office;
        url += "&department_id="+ department;
      }

      return await this.axios
        .get(url)
        .then(response => {
          this.$vs.loading.close();
          let data = response.data.data;
          this.MonthlyTimeSheet = data.responseOfMonthlyTimeSheet;
          this.monthlySearchresult = data.responseOfMonthlyTimeSheet;
          this.totalActiveMinutesOfMonth = data.totalActiveMinutes;
          this.totalPage = Math.ceil(
            data.responseOfMonthlyTimeSheet.count / this.perPage
          );
          this.totalActiveMinutesOfMonth = data.totalUserWorkedMinutes;
          this.daysWorked = data.totalWorkingDays;
          for (let j = 0; j < this.MonthlyTimeSheet.length; j++) {
            const parentElement = this.MonthlyTimeSheet[j];
            let myobj = {};
            myobj.User = parentElement.firstname + " " + parentElement.lastname;

            for (let i = 0; i < parentElement.dateWiseData.length; i++) {
              const element = parentElement.dateWiseData[i];

              myobj[
                `${this.MonthDates[i].Date} ${this.MonthDates[i].Day}`
              ] = this.convertToTime(element.activeMinutes);
            }
            this.csvMonthData.push(myobj);
          }
          return true;
        })
        .catch(e => {
          this.showError(e);
          return false;
        });
    },
       getOfficeAndDepartment(){
      if(this.office_id){
          this.$vs.loading({ color: "primary" });
          let url = "office/getAll";
          this.axios
            .get(url)
            .then(response => {
              this.$vs.loading.close();
              let data = response.data.data;
              let selectedOffice = data.filter((i) => i.id == this.office_id);
              this.officepdf = selectedOffice[0].office_name;
            })
            .catch(e => {
              this.showError(e);
            });
        }
  }
  },
    destroyed() {
    EventBus.$off('monthTimesheetPDF');
    EventBus.$off('reload_details');
  },
};
</script>
<style scoped>
.time-box-warning{
    background-color: rgba(var(--vs-warning), 1) !important;
    color: #fff;
    border-radius: 6px;
    width: 100px;
    border: 1px black;
    padding: 5px;
    margin: 2px;
    text-align: center;
    float: left;
}
</style>